import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { metaOverrideSet } from './metaOverrideSet';
import { GuidedHouseholdReviewOutroHowWeBringThisToLifeLayout } from './layout';


export const GuidedHouseholdReviewOutroHowWeBringThisToLifeTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={withGuidedHouseholdReviewLayout(GuidedHouseholdReviewOutroHowWeBringThisToLifeLayout)}
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
    />
  );
};

GuidedHouseholdReviewOutroHowWeBringThisToLifeTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
